<div class="relative">
	<div class="relative px-6 py-4">
		<div class="flex flex-row items-center justify-between">
			<h2 class="text-left font-bold leading-none text-gray-800">{{ headline }}</h2>
			<button
				class="z-10 flex h-8 w-8 appearance-none items-center justify-center text-base text-blue-500 outline-none transition-colors duration-150 ease-in-out hover:text-orange-500 focus:outline-none"
				(click)="onClose()"
			>
				<fa-icon [icon]="faClose"></fa-icon>
			</button>
		</div>
		<div class="my-2 text-sm">
			{{ browserText }}
		</div>
		<div>
			<button
				class="mt-auto block w-full transform appearance-none rounded-lg bg-blue-500 p-2 text-sm font-medium text-white shadow transition-all duration-700 ease-in-out hover:bg-orange-500"
				(click)="onClose()"
			>
				{{ btn }}
			</button>
		</div>
	</div>
</div>
